// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"69d4ea74","444":"9b0c9265"}[chunkId] + ".chunk.js";
};